import { PluginName } from 'editor/src/store/plugins/types';

export const EtsyPersonalizationPlugins = [PluginName.AIPersonalization, PluginName.emailWorkflowPersonalization];

export const ShopifyPersonalizationPlugins = [
  PluginName.shopifyPersonalization,
  PluginName.shopifyPersonalizationInEditor,
];
